export function fontResizer(restaurantName, type='top') {


    if (restaurantName) {

        let restTitleLength = restaurantName.length

        // Check if we are in mobile, tablet or desktop views
        var windowWidth = window.innerWidth
        if (windowWidth >= 800) {
            windowWidth = 400;
        }

        let availableSpace = 0
        let widthPerLetter = 0
        let fontSize = 10

        const calculateFontSize = () => {

            if (type === 'top') {
                availableSpace = windowWidth - 50;
            } else if (type === 'btn') {
                availableSpace = (windowWidth / 2 - 8);
            }

            widthPerLetter = availableSpace / restTitleLength;
            fontSize = widthPerLetter * 1.5;
            if (fontSize > 20.8) fontSize = 20.8
            // if (fontSize > 17.5) fontSize = 17.5

            return fontSize;
        }
        return calculateFontSize();
    }
}